import styled, { keyframes } from "styled-components";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(-360deg);
  }
`;

interface LoadingProps {
  mostrar: boolean;
  height?: number;
}

export const LoadingContainer = styled.div<LoadingProps>`
  width: 2.4rem;
  height: ${(props) => props.height ?? "2.4"}rem;
  animation: ${rotate} 2s linear infinite;
  display: ${(props) => (props.mostrar ? "flex" : "none")};
  align-self: center;
`;
